import React, { useState } from 'react';
import { Search } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const TrackApplication = () => {
    const [refNo, setRefNo] = useState('');
    const [dob, setDob] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // handle tracking logic here
        console.log({ refNo, dob });
    };

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,500;1,400&family=DM+Sans:wght@400;500;600&display=swap');

        .ta-page {
          font-family: 'DM Sans', sans-serif;
          background: #f4f7f9;
          min-height: 100vh;
          color: #1a2e3d;
        }

        /* Hero */
        .ta-hero {
          background: #162b56;
          padding: 56px 32px 48px;
          border-bottom: 2px solid #c9a84c;
        }

        .ta-hero-inner {
          max-width: 560px;
          margin: 0 auto;
          text-align: center;
        }

        .ta-eyebrow {
          font-size: 10.5px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #c9a84c;
          margin-bottom: 14px;
        }

        .ta-hero h1 {
          font-family: 'Lora', serif;
          font-size: 34px;
          font-weight: 500;
          color: #d9e8f0;
          margin-bottom: 12px;
          line-height: 1.25;
        }

        .ta-hero p {
          font-size: 14px;
          color: #7a98a8;
          line-height: 1.75;
        }

        /* Form card */
        .ta-body {
          max-width: 480px;
          margin: 0 auto;
          padding: 48px 32px 64px;
        }

        .ta-card {
          background: #ffffff;
          border: 1px solid rgba(15,31,46,0.08);
          border-radius: 12px;
          padding: 36px 32px;
        }

        .ta-section-label {
          font-size: 10.5px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #c9a84c;
          margin-bottom: 24px;
          padding-bottom: 10px;
          border-bottom: 1px solid rgba(201,168,76,0.2);
        }

        /* Field */
        .ta-field {
          margin-bottom: 20px;
        }

        .ta-label {
          display: block;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #546e7a;
          margin-bottom: 7px;
        }

        .ta-input {
          width: 100%;
          height: 44px;
          padding: 0 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: #1a2e3d;
          background: #f4f7f9;
          border: 1px solid rgba(15,31,46,0.12);
          border-radius: 8px;
          outline: none;
          box-sizing: border-box;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }

        .ta-input:focus {
          border-color: #c9a84c;
          box-shadow: 0 0 0 3px rgba(201,168,76,0.12);
          background: #fff;
        }

        .ta-input::placeholder {
          color: #a0b8c4;
        }

        /* Button */
        .ta-btn {
          width: 100%;
          height: 46px;
          margin-top: 8px;
          background: #0f1f2e;
          color: #d9e8f0;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: background 0.2s ease;
        }

        .ta-btn:hover {
          background: #162534;
        }

        .ta-btn:active {
          background: #0a1720;
        }

        /* Note */
        .ta-note {
          margin-top: 20px;
          border-left: 3px solid #c9a84c;
          background: #fff;
          border-radius: 8px;
          border: 1px solid rgba(201,168,76,0.2);
          border-left: 3px solid #c9a84c;
          padding: 14px 18px;
        }

        .ta-note-label {
          font-size: 10.5px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #c9a84c;
          margin-bottom: 4px;
        }

        .ta-note-text {
          font-size: 13px;
          color: #4a6475;
          line-height: 1.7;
        }

        @media (max-width: 560px) {
          .ta-hero { padding: 40px 20px 36px; }
          .ta-body { padding: 32px 20px 48px; }
          .ta-card { padding: 28px 20px; }
          .ta-hero h1 { font-size: 28px; }
        }
      `}</style>

            <Header />
            <div className="ta-page">

                {/* Hero */}
                <div className="ta-hero">
                    <div className="ta-hero-inner">
                        <h1>Track Your Application</h1>
                        <p>Enter your application reference number and date of birth to check the current status of your application.</p>
                    </div>
                </div>

                {/* Form */}
                <div className="ta-body">
                    <div className="ta-card">
                        <p className="ta-section-label">Application Details</p>

                        <form onSubmit={handleSubmit}>
                            <div className="ta-field">
                                <label className="ta-label" htmlFor="refNo">
                                    Application Reference No.
                                </label>
                                <input
                                    id="refNo"
                                    type="text"
                                    className="ta-input"
                                    placeholder="e.g. ICAC-2024-000123"
                                    value={refNo}
                                    onChange={(e) => setRefNo(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="ta-field">
                                <label className="ta-label" htmlFor="dob">
                                    Date of Birth
                                </label>
                                <input
                                    id="dob"
                                    type="date"
                                    className="ta-input"
                                    value={dob}
                                    onChange={(e) => setDob(e.target.value)}
                                    required
                                />
                            </div>

                            <button type="submit" className="ta-btn">
                                <Search size={15} strokeWidth={2} />
                                Track Application
                            </button>
                        </form>
                    </div>


                </div>

            </div>

            <Footer />
        </>
    );
};

export default TrackApplication;